import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Pak Hendra",
    role: "Pemilik Konveksi Seragam, Bandung",
    rating: 5,
    text: "Sudah langganan order seragam kantor di Lapak Bordir. Hasilnya rapi, jahitan presisi, dan paling penting—delivery on time meski volumenya ratusan pcs. Recommended.",
  },
  {
    name: "Ibu Sinta",
    role: "Brand Owner, Jakarta",
    rating: 5,
    text: "Saya cuma order 5 pcs kemeja sample untuk brand baru. Banyak vendor menolak karena minimal order, tapi Lapak Bordir terima dengan kualitas yang sama. Salut.",
  },
  {
    name: "Pak Dimas",
    role: "Event Organizer, Surabaya",
    rating: 5,
    text: "Order 200 topi event kurang dari 7 hari. Bordir logo sponsor tajam, posisi semua simetris. Klien kami puas, kami pun jadi lebih mudah closing project berikutnya.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimoni"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-background"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
            Suara Pelanggan
          </span>
          <h2
            data-testid="testimonials-headline"
            className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
          >
            Dipercaya bisnis & individu di seluruh Indonesia.
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-muted-foreground leading-relaxed">
            Cerita singkat dari beberapa klien yang sudah memesan dan kembali memesan lagi.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              data-testid={`testimonial-card-${idx}`}
              className="relative p-7 md:p-8 rounded-xl bg-secondary border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <Quote className="w-8 h-8 text-primary/30 mb-4" />

              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-[#C97A4E] text-[#C97A4E]"
                  />
                ))}
              </div>

              <p className="font-body text-sm md:text-base leading-relaxed text-foreground/85">
                "{t.text}"
              </p>

              <div className="mt-6 pt-5 border-t border-border">
                <div className="font-heading font-semibold text-foreground">
                  {t.name}
                </div>
                <div className="font-body text-xs text-muted-foreground mt-0.5">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
